import axios, { AxiosError } from 'axios'
import { logoutEmitter } from './eventEmitter'
import { notification } from 'antd'

const onResponseError = (error: AxiosError) => {
  if (error.response && error.response.status === 500) {
    notification.error({
      message: '予期せぬエラーが発生しました。',
      description: '時間をおいて再度お試しください。'
    })
  }

  if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
    notification.error({
      message: 'ネットワークエラー',
      description: '時間をおいて再度お試しください。'
    })
  }

  if (error.response && error.response.status === 401) {
    logoutEmitter.emit('eventLogout')
  }

  throw error
}

axios.interceptors.response.use(undefined, onResponseError)
